import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { CryptocurrencyPricesHeading } from "../../../Constant";
import { CRYPTO_PRICE_DATA } from "../../../Data/Widgets/ChartWidgets";

const CryptocurrencyPrices = () => {

  return (
    <Col xl="6" lg="12" className="xl-50">
      <Card>
      <CommonCardHeader title={CryptocurrencyPricesHeading} className="border-bottom-1" />
        <CardBody>
          <div className="chart-container crypto-chart">
            <Row>
              <Col xs="12">
                <div id="chart-crypto">
                  <ReactApexChart options={CRYPTO_PRICE_DATA} series={CRYPTO_PRICE_DATA.series} type="area" id="chart-widget7" height={400}/>
                </div>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CryptocurrencyPrices;
